import { OrderStatus, PaymentMethod, PaymentStatus } from '@/models/order.model';
import { StepType } from '@/models/step.model';
import { Dayjs } from 'dayjs';

export enum OrderFiltersFields {
  USER = 'user',
  STATUS = 'status',
  LIMIT = 'limit',
  CURSOR = 'cursor',
  ADDRESS = 'address',
  PAYMENT_METHOD = 'payment_status',
  PAYMENT_STATUS = 'payment_instrument',
  CREATED = 'created',
  TRIPLETEX_ORDER_NUMBER = 'tripletex_order_number',
  STEP_NAME = 'step_name',
}

export type TOrderFiltersValues = {
  [OrderFiltersFields.STATUS]?: OrderStatus;
  [OrderFiltersFields.USER]?: string;
  [OrderFiltersFields.LIMIT]?: number;
  [OrderFiltersFields.CURSOR]?: string;
  [OrderFiltersFields.PAYMENT_STATUS]?: PaymentStatus;
  [OrderFiltersFields.PAYMENT_METHOD]?: PaymentMethod;
  [OrderFiltersFields.ADDRESS]?: string;
  [OrderFiltersFields.CREATED]?: Dayjs;
  [OrderFiltersFields.TRIPLETEX_ORDER_NUMBER]?: string;
  [OrderFiltersFields.STEP_NAME]?: StepType;
};

export enum UploadConditionReportFields {
  CONDITION_REPORT_CREATED_AT = 'condition_report_created_at',
  RATE_REPORT_CREATED_AT = 'rate_report_created_at',
  CONDITION_REPORT_INCLUDES_RATE = 'condition_report_includes_rate',
  PRICE = 'price',
  FILES = 'files',
}

export type TUploadConditionReportFields = {
  [UploadConditionReportFields.CONDITION_REPORT_CREATED_AT]: string;
  [UploadConditionReportFields.RATE_REPORT_CREATED_AT]: string;
  [UploadConditionReportFields.PRICE]: number;
};
